import { Component, computed, Inject, isDevMode, PLATFORM_ID, signal } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ToggleService } from '../../template-components/header/toggle.service';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { UserSessionService } from '../../ui-framework/global-services/user-session/user-session.service';
import { AppInitService } from '../../ui-framework/global-services/app-init/app-init.service';
import { ServiceContainerService } from '../../ui-framework/global-services/service-container.service';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { LogInStatus, UserRoleListItem2 } from '../../data-services/api-models/config-service-models';

@Component({
    selector: 'app-sign-in',
    imports: [RouterLink, MatInputModule, MatFormFieldModule, ReactiveFormsModule, FormsModule, MatSelectModule],
    templateUrl: './sign-in.component.html',
    styleUrl: './sign-in.component.scss'
})
export class SignInComponent {
    signInForm = new FormGroup({
        email: new FormControl('', [Validators.required]),
        password: new FormControl('', [Validators.required, Validators.minLength(6)])
    });
    readonly loginUrl: string;
    isMultipleAllocationPresent = signal<boolean>(false);
    selectedAllocationId = signal<string | undefined>(undefined);
    offices = signal<UserRoleListItem2[]>([]);

    constructor(
        @Inject(PLATFORM_ID) private readonly platformId: Object,
        public toggleService: ToggleService,
        private readonly userSession: UserSessionService,
        private readonly initService: AppInitService,
        private readonly services: ServiceContainerService,
        router: Router
    ) {
        this.loginUrl = router.url;
    }

    private _isLoginProgress = signal(false);
    readonly canLogin = computed(
        () => !this._isLoginProgress() && this.initService.isInitialized()
    );
    ngOnInit(): void {
        // Initialize theme and direction on component load
        this.toggleService.initializeTheme();
        if (isDevMode()) {
            this.signInForm.patchValue({
                email: 'testuser01',
                password: '12345678'
            });
        }
    }

    // Toggle theme between light and dark
    toggleTheme() {
        this.toggleService.toggleTheme();
    }

    // Toggle direction between LTR and RTL
    toggleDirection() {
        this.toggleService.toggleDirection();
    }

    // Password Show/Hide
    password: string = '';
    isPasswordVisible: boolean = false;
    togglePasswordVisibility(): void {
        this.isPasswordVisible = !this.isPasswordVisible;
    }
    onPasswordInput(event: Event): void {
        const inputElement = event.target as HTMLInputElement;
        this.password = inputElement.value;
    }

    onLocationSelectionChanged($event: MatSelectChange) {
        this.selectedAllocationId.set($event.value.allocationId);
        this._isLoginProgress.set(false);
    }

    onSubmit() {
        // Browser-specific code

        if (this.signInForm.valid) {
            this._isLoginProgress.set(true);
            this.userSession.loginUser({
                userId: this.signInForm.value.email!,
                password: this.signInForm.value.password!,
                isBackGroundLogin: false,
                actualUserId: undefined,
                systemIP: undefined,
                allocationId: this.selectedAllocationId()
            }).subscribe({
                next: (response) => {
                    if (response && response.status == LogInStatus.Success) {
                        this.userSession.setLoginResponse(response, this.loginUrl, false);
                        if (this.isMultipleAllocationPresent()) {
                            this.isMultipleAllocationPresent.set(false);
                        }

                    }
                    else if (
                        response?.status == LogInStatus.NeedOfficeSelection
                    ) {
                        this.isMultipleAllocationPresent.set(true);
                        this.offices.set(response?.userRights?.roles!);
                        this.offices().forEach(office => {
                            office.description = response.userRights?.offices?.find((o: any) => o.id === office.unitId)?.description ?? "";
                        })
                    }
                    else {
                        this.services.alertsService
                            .showAlert('Login Failed', 'Login', 'Error')
                            .subscribe();
                        this._isLoginProgress.set(false);
                        if (this.isMultipleAllocationPresent())
                            this.isMultipleAllocationPresent.set(false);
                    }
                },
                error: (error) => {
                    console.error('Login failed', error);
                    this._isLoginProgress.set(false);
                    throw error;
                    // Handle login error, e.g., show error message
                }
            });
        }

    }
}



